var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPartnerTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    draggable: "false",
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.25 0H6.74996C3.02171 0 0 3.02171 0 6.74996V29.25C0 32.9782 3.02171 35.9999 6.74996 35.9999H29.25C32.9782 35.9999 35.9999 32.9781 35.9999 29.25V6.74996C36 3.02171 32.9782 0 29.25 0ZM26.955 13.959L26.9685 14.5327C26.9685 20.3917 22.5112 27.1417 14.3595 27.1417C11.8575 27.1417 9.52868 26.4083 7.56671 25.1505C7.91325 25.1909 8.26644 25.2134 8.62423 25.2134C10.701 25.2134 12.6112 24.5047 14.1277 23.3167C12.1882 23.2807 10.5525 21.9982 9.98772 20.2387C10.2599 20.2882 10.5345 20.3152 10.8225 20.3152C11.2275 20.3152 11.6189 20.2635 11.9902 20.1623C9.96293 19.7527 8.4352 17.964 8.4352 15.8175V15.7613C9.03368 16.0943 9.71542 16.2923 10.4422 16.3171C9.25416 15.5228 8.47117 14.1661 8.47117 12.6293C8.47117 11.8171 8.68944 11.0566 9.06965 10.4018C11.2544 13.0838 14.5214 14.8478 18.2046 15.0323C18.1281 14.7083 18.0899 14.3686 18.0899 14.0221C18.0899 11.5764 20.0744 9.59182 22.5224 9.59182C23.7959 9.59182 24.948 10.1295 25.7579 10.9913C26.7659 10.791 27.7154 10.422 28.5727 9.91578C28.2419 10.9508 27.5399 11.8193 26.6242 12.3682C27.5174 12.2625 28.3747 12.0217 29.1689 11.6707C28.575 12.5572 27.8212 13.338 26.955 13.959Z",
    fill: "#898989"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartnerTwitter);
export default __webpack_public_path__ + "static/media/partner-twitter.f3f16e5e.svg";
export { ForwardRef as ReactComponent };